import type { UserRoles } from 'core/base';
import { UsersService } from 'core/services';
import type { UserId } from 'core/types';
import { useMutation, useQuery } from '@tanstack/react-query';

const usersService = new UsersService();
// TODO: maybe has to be global hooks
export const useUsers = (enabled = true) => {
  return useQuery(['users'], () => usersService.getAll(), { enabled });
};
export const useUser = (enabled = true) => {
  return useQuery(['user'], () => usersService.getUserInfo(), { enabled });
};

export const useRoles = (enabled = true) => {
  return useQuery(['roles'], () => usersService.getRoles(), { enabled });
};

export const useRolesByRole = (enabled = true) =>
  useQuery(['roles-by-role'], () => usersService.getRolesByRole(), { enabled });

export const useUpdateUserRoles = () => {
  return useMutation(({ id, roles }: { id: UserId; roles: UserRoles[] }) =>
    usersService.updateUserRoles(id, roles),
  );
};

export const useUpdateManyUsersRoles = () => {
  return useMutation((usersForUpdate: { userID: UserId; roles: UserRoles[] }[]) =>
    usersService.updateManyUsersRoles(usersForUpdate),
  );
};
